import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d6b47b9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "container"
}
const _hoisted_3 = { class: "g-card logistics-tracking" }
const _hoisted_4 = { class: "form-subtitle" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "logistics-tracking-detail" }
const _hoisted_7 = {
  key: 0,
  class: "icon"
}
const _hoisted_8 = { class: "detail" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  key: 1,
  class: "logistics-tracking-empty"
}
const _hoisted_11 = { class: "g-card order-receiver-info" }
const _hoisted_12 = { class: "form-subtitle" }
const _hoisted_13 = { class: "package-info" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 包裹单号 ", -1))
const _hoisted_16 = { class: "text" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 保价金额 ", -1))
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 线路 ", -1))
const _hoisted_22 = { class: "text" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 称重重量 ", -1))
const _hoisted_25 = { class: "text" }
const _hoisted_26 = { class: "item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 计费重量 ", -1))
const _hoisted_28 = { class: "text" }
const _hoisted_29 = {
  key: 0,
  class: "item"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 尺寸 ", -1))
const _hoisted_31 = { class: "text" }
const _hoisted_32 = { class: "text-item" }
const _hoisted_33 = { class: "text-item" }
const _hoisted_34 = { class: "text-item" }
const _hoisted_35 = {
  key: 1,
  class: "item image"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 图片 ", -1))
const _hoisted_37 = { class: "image-items" }
const _hoisted_38 = ["src", "onClick"]
const _hoisted_39 = {
  key: 2,
  class: "invoice"
}
const _hoisted_40 = { class: "item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 运费 ", -1))
const _hoisted_42 = { class: "text" }
const _hoisted_43 = {
  key: 0,
  class: "item"
}
const _hoisted_44 = { class: "label" }
const _hoisted_45 = { class: "text" }
const _hoisted_46 = { class: "item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, " 运费 ", -1))
const _hoisted_48 = { class: "text price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Gallery = _resolveComponent("Gallery")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.packageInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Icon, {
                class: "icon",
                icon: "icon_line"
              }),
              _createTextVNode("物流信息 ")
            ]),
            (_ctx.router.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.router, (item, idx) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: item.id,
                        class: _normalizeClass(["tracking-item", [
                { latest: idx == 0 },
                { hidden: idx > 2 && !_ctx.isShowMore },
              ]])
                      }, [
                        (idx === 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                          : (_openBlock(), _createBlock(_component_Icon, {
                              key: 1,
                              class: "icon",
                              icon: "icon_logistics"
                            })),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(item.location ? item.location + '，' : '') + _toDisplayString(item.event), 1),
                          _createElementVNode("div", null, _toDisplayString(item.time), 1)
                        ])
                      ], 2))
                    }), 128))
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showMoreTracking && _ctx.showMoreTracking(...args))),
                    class: _normalizeClass(["show-more", { expanded: !_ctx.isShowMore }])
                  }, [
                    _createVNode(_component_Icon, {
                      icon: "btn_fold",
                      class: "icon"
                    })
                  ], 2)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.packageInfo.status_pay === 1
              ? '包裹已出库，等待路由信息同步.'
              : '等待出库...'), 1)
                ]))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Icon, {
                class: "icon",
                icon: "icon_fillpackage"
              }),
              _createTextVNode("包裹详情 ")
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.packageInfo.package_attr_num), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, " ￥" + _toDisplayString(_ctx.packageInfo.declare_amount), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.packageInfo.express.title || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.packageInfo.weight), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.packageInfo.rate_weight), 1)
              ]),
              (_ctx.packageInfo.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("span", _hoisted_31, [
                      _createElementVNode("span", _hoisted_32, " 长 " + _toDisplayString(_ctx.packageInfo.length) + " cm ", 1),
                      _createElementVNode("span", _hoisted_33, " 宽 " + _toDisplayString(_ctx.packageInfo.width) + " cm ", 1),
                      _createElementVNode("span", _hoisted_34, " 高 " + _toDisplayString(_ctx.packageInfo.height) + " cm ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.packageInfo.photos.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _hoisted_36,
                    _createElementVNode("div", _hoisted_37, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageInfo.photos, (img, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "image-item",
                          key: idx
                        }, [
                          _createElementVNode("img", {
                            src: img,
                            mode: "widthFix",
                            onClick: ($event: any) => (_ctx.navToImg(idx))
                          }, null, 8, _hoisted_38)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.packageInfo.package_detail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.packageInfo.package_detail.base_price
                    ? '￥' + _ctx.packageInfo.package_detail.base_price
                    : '仓库测算中'), 1)
                    ]),
                    (_ctx.packageInfo.package_detail.declare_price > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createTextVNode(" 保价 "),
                            _createVNode(_component_Icon, {
                              onClick: _ctx.showDeclareTips,
                              class: "declare-explanation",
                              icon: "btn_explanation"
                            }, null, 8, ["onClick"])
                          ]),
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.packageInfo.package_detail.declare_price
                    ? '￥' + _ctx.packageInfo.package_detail.declare_price
                    : '仓库测算中'), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.packageInfo.price !== null
                  ? '￥' + _ctx.packageInfo.price
                  : '仓库测算中'), 1)
              ])
            ])
          ]),
          _createVNode(_component_Gallery, {
            "cur-img-index": _ctx.curImgIndex,
            visible: _ctx.isShowGallery,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isShowGallery) = $event)),
            "is-show-del": true,
            imgs: _ctx.packageInfo.photos
          }, null, 8, ["cur-img-index", "visible", "imgs"])
        ]))
      : _createCommentVNode("", true)
  ]))
}